<template>
  <div v-if="amount || order">
    <b-container fluid v-bind:class="{ border: !borderless }">
      <b-row v-if="title" class="title text-uppercase py-2">
        <b-col cols="12">{{ title }}</b-col>
      </b-row>
      <b-row v-bind:class="bodyClass">
        <b-col>
          <div v-for="(detail, index) in details" :key="index">
            <b-row
              v-if="detail.visible"
              v-bind:class="detailClass"
              class="py-2"
            >
              <b-col cols="7">{{ detail.title }}</b-col>
              <b-col cols="5" class="text-right">
                <div
                  v-for="(amountitem, index) in detail.amountitem"
                  :key="index"
                >
                  {{ $formatMoney(amountitem.amount, amountitem.currency) }}
                </div>
                <div v-if="!detail.amountitem || !detail.amountitem.length">
                  {{ $formatMoney(0, totalDetails.currency) }}
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="showAll || showTotal"
        class="total text-uppercase"
        v-bind:class="{ 'py-1': small, 'py-3': !small }"
      >
        <b-col cols="6">{{ $t("total_amount_summary.total") }}</b-col>
        <b-col cols="6" class="text-right">
          {{ $formatMoney(totalDetails.amount, totalDetails.currency) }}
        </b-col>
      </b-row>
      <b-row
        v-if="showOfferCode && false"
        class="text-uppercase table-summary"
        v-bind:class="{ 'py-1': small, 'py-3': !small }"
      >
        <b-col cols="12">
          <b-form inline>
            <b-input
              id="offer-code"
              :placeholder="$t('total_amount_summary.offer')"
            ></b-input>
            <b-button variant="primary-b" class="ml-auto">
              {{ $t("total_amount_summary.apply") }}
            </b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  AMOUNT_TYPE_SUBTOTAL,
  AMOUNT_TYPE_DISCOUNT,
  AMOUNT_TYPE_SHIPPING,
} from "@/lib/amount.js";
import { Money } from "@/lib/money.js";
import { buildAmount } from "@/lib/amount.js";
import { getDrugsQuantity } from "@/lib/drugs.js";

// Muestra un sumario de totales, subtotales, transporte, descuentos, iva, etc.
// permite configurar qué se muestra o deja de mostrar.
export default {
  name: "total-amount-summary",
  props: {
    title: String,
    // muestra todo.
    showAll: {
      default: true,
      type: Boolean,
    },
    // muestra subtotal
    showSubtotal: {
      default: false,
      type: Boolean,
    },
    // muestra descuentos
    showDiscount: {
      default: false,
      type: Boolean,
    },
    showOffer: {
      default: false,
      type: Boolean,
    },
    showShipping: {
      default: false,
      type: Boolean,
    },
    showTaxes: {
      default: false,
      type: Boolean,
    },
    showTotal: {
      default: false,
      type: Boolean,
    },
    order: {
      default: undefined,
      type: Object,
    },
    amount: {
      default: undefined,
      type: Object,
    },
    borderless: {
      default: false,
      type: Boolean,
    },
    striped: {
      default: false,
      type: Boolean,
    },
    small: {
      default: false,
      type: Boolean,
    },
    showOfferCode: {
      default: false,
      type: Boolean,
    },
    items: {
      default: undefined,
      type: Array,
    },
  },
  data() {
    return {
      preferrend_currency: undefined,
    };
  },
  computed: {
    subtotalWithoutDiscount() {
      let found = [];
      var total = new Money(0, this.amount.total.currency);
      var subtotal = new Money(0, this.amount.total.currency);
      var discount = new Money(0, this.amount.total.currency);

      var subtotals = this.amount.getAllDetailByType(AMOUNT_TYPE_SUBTOTAL);
      subtotals.forEach((element) => {
        subtotal.add(element);
      });
      var discounts = this.amount.getAllDetailByType(AMOUNT_TYPE_DISCOUNT);
      discounts.forEach((element) => {
        discount.add(element);
      });
      total.add(subtotal);
      total.add(discount);
      found.push(total);
      return found;
    },
    allShippingDetails() {
      if (this.amount) {
        if (typeof this.amount.getAllDetailByType !== "undefined") {
          return this.amount.getAllDetailByType(AMOUNT_TYPE_SHIPPING);
        } else {
          buildAmount(Object.values(this.cartData.item_list.drugs));
        }
      }
      return undefined;
    },
    totalDetails() {
      if (!this.amount) {
        return undefined;
      }
      var total = new Money(
        Number(this.amount.total.amount),
        this.amount.total.currency
      );
      return total;
    },
    taxesDetails() {
      if (!this.amount) {
        return undefined;
      }
      var taxes = new Money(
        Number(this.amount.taxes.amount),
        this.amount.taxes.currency
      );
      return taxes;
    },
    bodyClass() {
      if (!this.striped) {
        return ["border-top", "py-3", "table-summary"];
      }
      return [];
    },
    numProducts() {
      if (this.items) {
        return getDrugsQuantity(this.items);
      }
      if (this.order && this.order.item_list && this.order.item_list.drugs) {
        return getDrugsQuantity(this.order.item_list.drugs);
      }
      return 0;
    },
    detailClass() {
      if (this.striped) {
        return ["border-top", "py-1", "table-summary"];
      }
      return [];
    },
    details() {
      if (!this.amount) {
        return undefined;
      }

      return [
        {
          title: this.$t("total_amount_summary.subtotal_products", {
            nProducts: this.numProducts,
          }),
          amountitem: this.subtotalWithoutDiscount,
          visible: this.showAll || this.showSubtotal,
        },
        {
          title: this.$t("total_amount_summary.discount"),
          amountitem: this.amount.getAllDetailByType(AMOUNT_TYPE_DISCOUNT),
          visible: this.showAll || this.showDiscount,
        },
        {
          title: this.$t("total_amount_summary.offer"),
          amountitem: [new Money(0, this.amount.total.currency)], // TODO
          visible: this.showAll || this.showOffer,
        },
        {
          title: this.$t("total_amount_summary.shipping_costs"),
          amountitem: this.allShippingDetails,
          visible: this.showAll || this.showShipping,
        },
        {
          title: this.$t("total_amount_summary.taxes"),
          amountitem: [this.taxesDetails],
          visible: this.showAll || this.showTaxes,
        },
      ];
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        total_amount_summary: {
          discount: "Discount",
          shipping_costs: "Shipping costs",
          subtotal_products: "Subtotal ({nProducts}) products",
          subtotal: "Subtotal",
          taxes: "Taxes",
          total: "Total",
          offer: "Offer code",
          apply: "Apply",
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: $font-size-medium;
}

.total {
  background-color: $table-summary-total-bg-color;
  font-size: $font-size-medium;
  font-weight: bold;
}
.table-summary {
  background-color: $table-summary-bg-color;
}
</style>
